import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const LeadersTeamPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">Our Leaders and Team</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Leadership and expertise driving our agricultural success
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Board of Directors */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mb-16"
          >
            <div className="flex items-center mb-8">
              <div className="bg-purple-600 text-white p-3 rounded-full mr-4">
                <i className="fas fa-user-tie text-2xl"></i>
              </div>
              <h2 className="text-3xl font-semibold text-gray-900">Our Board of Directors</h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { name: 'Mr Stan Chikakuda', role: 'Executive Chair' },
                { name: 'Mr Robin Kilner', role: 'Independent non-executive' },
                { name: 'Mr Patrick Staniland', role: 'Independent non-executive' }
              ].map((director, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.3 }}
                  className="bg-white p-6 rounded-lg shadow-md text-center"
                >
                  <div className="bg-gray-200 w-24 h-24 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <i className="fas fa-user text-gray-500 text-3xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">{director.name}</h4>
                  <p className="text-gray-600 text-sm">{director.role}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          {/* Executive Committee */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="bg-gradient-to-r from-purple-50 to-pink-50 p-8 rounded-xl"
          >
            <div className="flex items-center mb-8">
              <div className="bg-purple-600 text-white p-3 rounded-full mr-4">
                <i className="fas fa-users-cog text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900">Executive Committee (ExCo)</h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                'Andrew Chinguwo',
                'Veronica Kagonegone',
                'Lennick Makause'
              ].map((member, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="bg-white p-6 rounded-lg shadow-md text-center"
                >
                  <div className="bg-purple-100 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <i className="fas fa-user text-purple-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900">{member}</h4>
                  <p className="text-purple-600 text-sm font-medium">Executive Committee Member</p>
                </motion.div>
              ))}
            </div>
            <p className="text-gray-700 mt-6 text-center">
              Our team is organized by departments with Heads of Department leading their respective areas, working collaboratively to achieve our mission and vision.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LeadersTeamPage;
